module.exports = __webpack_public_path__ + "img/banner_kadra.bd65b022.jpg";